export default __webpack_public_path__ + "static/media/pizzas.97b482a9.png";